<template>
  <div class="widget">
    <el-carousel height="220px" indicator-position="outside">
      <el-carousel-item v-for="item in carousels" :key="item.carousel_id">
        <a :href="item.carousel_url" target="_blank" style="position: relative; display: block; height: 100%;">
          <img :src="item.carousel_img" style="width: 100%; height: 100%; object-fit: cover;" />
          <div style="position: absolute; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,.45); color: #fff; padding: 8px 12px; font-size: 14px;">
            {{ item.carousel_title }}
          </div>
        </a>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { getCarousels } from '@/api'

export default {
  name: 'CarouselWidget',
  data() {
    return { carousels: [] }
  },
  created() {
    getCarousels().then((res) => {
      this.carousels = res.data || []
    })
  }
}
</script>
